import React from 'react';
import LanguageSwitcher from '../LanguageSwitcher';
import {
	FaFacebook,
	FaLinkedin,
	FaPhone,
	FaTelegram,
	FaTiktok,
	FaWhatsapp,
	FaYoutube,
} from 'react-icons/fa';
import { NavLink } from 'react-router-dom';

const SmallBar = () => {
	return (
		<div className='fixed bg-black text-white top-0 w-full'>
			<div className=' px-5 w-[94%] m-auto flex justify-between items-center '>
				<div className='flex justify-center items-center gap-5 text-xl'>
					<NavLink to='https://www.facebook.com/profile.php?id=61550304061074&mibextid=ZbWKwL'>
						<FaFacebook />
					</NavLink>
					<NavLink to='https://www.linkedin.com/company/ai-coding-academy/'>
						<FaLinkedin />
					</NavLink>
					<NavLink to='https://t.me/Ai_students'>
						<FaTelegram />
					</NavLink>
					<NavLink to='https://www.youtube.com/@hosam_mhmd_ali'>
						<FaYoutube />
					</NavLink>
					<NavLink to='/'>
						<FaPhone />
					</NavLink>
				</div>
				<div>
					<LanguageSwitcher />
				</div>
			</div>
		</div>
	);
};

export default SmallBar;
